// extracted by mini-css-extract-plugin
module.exports = {"pageName":"GeneratePurchaseOrderComponent_pageName__LGJ6C","header":"GeneratePurchaseOrderComponent_header__3hwWK","backButton":"GeneratePurchaseOrderComponent_backButton__3jEal"};